<template>
  <div class="columns is-marginless infoBorderReseau" :class="{'selectt': infoReseauxTempo.select}">
    <div class="column is-paddingless is-narrow position_relative">
      <img class="sizeImgReseau" :src="url">
      <div class="pointer level bgBlur">
        <div class="level-left"></div>
        <div
          class="level-right"
          v-if="getTarif">
          <p class="p_size18 has-text-weight-bold has-text-white goToLeft">
            {{tarif(getTarif)}} HT
          </p>
        </div>
      </div>
    </div>
    <div class="column is-paddingless has-background-white">
      <div class="padding_medium">
        <p @click="show = true" class="pointer is-size-7">
          <label class="has-text-default">Nom du réseau</label> <br>
          <strong class="p_size16 has-text-weight-bold has-text-link">
            {{infoReseauxTempo.libelle}}
          </strong>
        </p>
        <div @click="show = true" class="pointer media topViolet bottomViolet">
          <b-icon
            icon="timer"
            size="is-medium"
            class="media-left color-icon">
          </b-icon>
          <div class="media-content is-size-7 has-text-default">
            <label>Période d'affichage</label>
            <p class="p_size14 has-text-weight-bold has-text-link">{{periode}}</p>
          </div>
        </div>
        <div
          @click="show = true"
          class="pointer columns is-multiline is-marginless is-gap color-icon"
        >
          <div
            class="column is-half is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="sign-text"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">Nombre de faces</label><br>
                <p class="p_size14 has-text-weight-bold has-text-link">
                  {{infoReseauxTempo.extensionOpportunite.facesSouhaitees}}
                </p>
              </div>
            </div>
          </div>
          <div
            class="column is-half is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="timer"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default"> Durée </label><br>
                <p class="p_size14 has-text-weight-bold has-text-link">{{duree}}</p>
              </div>
            </div>
          </div>
          <div
            class="column is-half is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="calendar-check"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default"> Jour de depart </label><br>
                <p class="p_size14 has-text-weight-bold has-text-link">
                  {{jour}}
                </p>
              </div>
            </div>
          </div>
          <div
            class="column is-half is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="city"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default"> Ville </label><br>
                <p class="p_size14 has-text-weight-bold has-text-link">
                  {{infoReseauxTempo.ville}}
                </p>
              </div>
            </div>
          </div>
          <div
            class="column is-half is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="vector-intersection"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default"> Format </label><br>
                <p class="p_size14 has-text-weight-bold has-text-link">
                  {{infoReseauxTempo.format}}
                </p>
              </div>
            </div>
          </div>
          <div
            class="column is-12 is-paddingless bottomViolet"
            v-if="infoReseauxTempo.extensionOpportunite.commentaire">
            <div class="media">
              <div class="media-content is-size-7">
                <label class="has-text-weight-bold has-text-link p_size14">
                  Commentaire : </label><br>
                <p class="p_size12 has-text-default has-text-link">
                  {{infoReseauxTempo.extensionOpportunite.commentaire}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-narrow">
      <div class="has-text-centered mb-btnaction">
        <div class="icon-forme pointer" :class="{'icon-select': infoReseauxTempo.select}"
          @click="contolSelect()">
          <b-icon icon="cart"
          type="is-white" custom-class="icon-position"></b-icon>
        </div>
        <p class="p_size10 has-text-default ml-5px" v-if="!infoReseauxTempo.select">
          Sélectionner</p>
        <p class="p_size10 has-text-default ml-5px" v-else>
          Retirer</p>
      </div>
      <div class="has-text-centered mb-btnaction">
        <div class="icon-forme topViolet pointer" @click="show = true">
          <b-icon icon="information"
          type="is-white" custom-class="icon-position"></b-icon>
        </div>
        <p class="p_size10 has-text-default ml-5px">
          Plus d'infos</p>
      </div>
      <div class="has-text-centered mb-btnaction">
        <div class="icon-diapo topViolet pointer" @click="showDiapo = true">
          <b-icon icon="image"
          type="is-white" custom-class="icon-position"></b-icon>
        </div>
        <p class="p_size10 has-text-default ml-5px">
          Diaporama</p>
      </div>
      <div class="has-text-centered topViolet mb-btnaction">
        <app-export-excel
          :data="infoReseauxTempo.listeFaces"
          :nom="infoReseauxTempo.libelle"
          :periode="periode"
          :show-dimension="showDimension"/>
      </div>
    </div>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
      :duration="300"
      v-on:after-enter="bg = true"
      v-on:after-leave="bg = false">
      <app-detail-tempo-diapo :bg="bg" :detailFace="infoReseauxTempo"
      :idOpportunite="idOpportunite" v-if="show"/>
    </transition>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      :duration="1000"
      v-on:after-enter="bg = true"
      v-on:after-leave="bg = false">
      <app-diapo-tempo
        :detailTem="infoReseauxTempo.listeFaces"
        :reseau="infoReseauxTempo.libelle"
        :show-diapo="showDiapo"
        :bg="bg"
        v-if="showDiapo"/>
      </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { formatJour, calPeriode, urlPhoto, formatNum, formatDuree } from '@/services/opportunite/formatTab';
import exportExcel from '../../exportExcel';
import detailTempoDiapo from './detailTempoDiapo';
import diapoTempo from './diapoTempo';

export default {
  name: 'infoReseauxTempo',
  props: ['infoReseauxTempo', 'idOpportunite', 'showDimension'],
  components: {
    appExportExcel: exportExcel,
    appDetailTempoDiapo: detailTempoDiapo,
    appDiapoTempo: diapoTempo,
  },
  data() {
    return {
      show: false,
      showDiapo: false,
      bg: false,
    };
  },
  computed: {
    url() {
      return urlPhoto(this.infoReseauxTempo.urlPhoto);
    },
    periode() {
      if (this.infoReseauxTempo.extensionOpportunite.newPeriode) {
        return this.infoReseauxTempo.extensionOpportunite.newPeriode;
      }
      const d = this.infoReseauxTempo.extensionOpportunite.jourDepart;
      const w = this.infoReseauxTempo.extensionOpportunite.semaine;
      const y = this.infoReseauxTempo.extensionOpportunite.annee;
      return calPeriode(d, w, y);
    },
    jour() {
      return formatJour(this.infoReseauxTempo.jourDepart);
    },
    duree() {
      return formatDuree(this.infoReseauxTempo.dureeConservation);
    },
    getTarif() {
      let tarifNet = 0;
      let tarifDePose = 0;
      let taxeMunicipale = 0;
      let tarifImpression = 0;
      let tarifHT = 0;
      if (this.infoReseauxTempo.extensionOpportunite.tarifDePose) {
        tarifDePose = this.infoReseauxTempo.extensionOpportunite.tarifDePose;
      }
      if (this.infoReseauxTempo.extensionOpportunite.taxeMunicipale) {
        taxeMunicipale = this.infoReseauxTempo.extensionOpportunite.taxeMunicipale;
      }
      if (this.infoReseauxTempo.extensionOpportunite.tarifImpression) {
        tarifImpression = this.infoReseauxTempo.extensionOpportunite.tarifImpression;
      }
      if (this.infoReseauxTempo.extensionOpportunite.tarifHT) {
        tarifHT = this.infoReseauxTempo.extensionOpportunite.tarifHT;
      }
      if (this.infoReseauxTempo.extensionOpportunite.tarifNet) {
        tarifNet = this.infoReseauxTempo.extensionOpportunite.tarifNet;
        return tarifNet
        + tarifDePose
        + taxeMunicipale
        + tarifImpression;
      }
      return tarifHT
        + tarifDePose
        + taxeMunicipale
        + tarifImpression;
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.infoReseauxTempo.select = !this.infoReseauxTempo.select;
      if (this.infoReseauxTempo.select) {
        this.add(this.getTarif);
        this.addNbSelect();
      } else {
        this.substract(this.getTarif);
        this.substractNbSelect();
      }
    },
    tarif(t) {
      return formatNum(t);
    },
  },
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxTempo/infoReseauxTempo.vue